






































import { Watch, Prop, Component, Vue, Ref } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { Company } from '@/api/model/company'
import { ProviderInstance } from 'vee-validate/dist/types/types'

@Component
export default class InputMultiSelectUser extends Vue {
    @Ref() validator!: ProviderInstance
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly users!: User[]
    @Prop() readonly value!: any[]
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    @Prop({ type: Boolean, default: false }) readonly clearable!: boolean
    @Prop({ type: Boolean, default: false }) readonly white!: boolean
    selected: any[] = []
    showOptions: boolean = false

    created() {
        this.onValueChanged()
        window.addEventListener('click', this.onOutsideClick)
    }

    beforeDestroy() {
        window.removeEventListener('click', this.onOutsideClick)
    }

    @Watch('users')
    onUsersChanged() {
        this.selected = this.selected.filter(userId => {
            return this.users.some((user: User) => user.id === userId)
        })
        this.onSelectedChanged()
    }

    @Watch('value')
    onValueChanged() {
        this.selected = []

        if (!this.value) {
            return
        }

        this.value.forEach(v => {
            const option = this.findOptionByValue(v)
            if (option && this.selected.some(s => s === option.id) === false) {
                this.selected.push(option.id)
            }
        })
    }

    onSelectedChanged() {
        this.validator.validate(this.selected)
        this.$emit('input', this.selected.map(selected => {
            return this.users.find(user => user.id === selected)
        }))
    }

    toggleOptions(): void {
        if (!this.disabled) {
            this.showOptions = !this.showOptions
        }
    }

    toggleOption(userId: string) {
        if (this.disabled) {
            return
        }

        if (this.isSelected(userId)) {
            this.selected = this.selected.filter(value => value !== userId)
        } else {
            this.selected.push(userId)
        }

        this.onSelectedChanged()
    }

    isSelected(userId: string) {
        return this.selected.includes(userId)
    }

    findOptionByValue(value: User) {
        const users = this.users.filter(user => user.id === value.id)
        if (users.length > 0) {
            return users[0]
        }

        return null
    }

    getKey(user: User): string {
        if (user.keyVueBranches[0]) {
            return `${user.id}___${user.keyVueBranches[0].id}`
        }

        return `${user.id}`
    }

    get isClearable(): boolean {
        return this.clearable && this.selected.length && !this.disabled
    }

    clear(): void {
        this.selected = []
        this.onSelectedChanged()
        this.showOptions = false
    }

    get componentClass(): object {
        return {
            'input-multi-select-user': true,
            'input-multi-select': true,
            'input-select-user': true,
            'input-select': true,
            'input-select--disabled': this.disabled,
            'input-select--white': this.white,
        }
    }

    isCurrentCompany(company: Company): boolean {
        return this.$currentCompany.id === company.id
    }

    async onOutsideClick(e: Event) {
        const target = e.target as HTMLDivElement

        if (!this.$el.contains(target)) {
            this.showOptions = false
        }
    }
}
